"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeytipRef = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./KeytipData"), exports);
tslib_1.__exportStar(require("./KeytipData.types"), exports);
var useKeytipRef_1 = require("./useKeytipRef");
Object.defineProperty(exports, "useKeytipRef", { enumerable: true, get: function () { return useKeytipRef_1.useKeytipRef; } });
//# sourceMappingURL=index.js.map